module.exports = __webpack_public_path__ + "img/invoice-de-female-rp.10f1f84b.png";